var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h1',[_vm._v("しせいの学校管理者画面")]),_c('p',[_vm._v("学校コード XXXX")]),_c('PoseInfoTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }